import React from "react";
import { LegalShell, Section } from "../components/LegalShell";

const LAST_UPDATED = "26 February 2026";

export default function Security() {
    return (
        <LegalShell
            eyebrow="Trust"
            title="Security"
            subtitle="How EuroLaw Hub protects your account, your documents and your research."
            lastUpdated={LAST_UPDATED}
        >
            <Section title="Data protection">
                <p>
                    Your data is encrypted in transit and at rest. Documents,
                    conversations and account details are stored securely, with
                    protections applied at every layer of the service.
                </p>
                <p>
                    We collect only what the service needs to operate, and we retain
                    it only for as long as it is needed. The details are set out in
                    our <a href="/privacy" className="underline">Privacy Policy</a>.
                </p>
            </Section>

            <Section title="Access control">
                <p>
                    Access to your data is restricted and monitored. Within the
                    platform, you can only see and change your own documents,
                    conversations and alerts. Administrative access is limited to
                    designated EuroLaw Hub staff, is never self-service, and is
                    logged.
                </p>
                <p>
                    Your password is never visible to us, never logged and never
                    shared. If your account is ever suspended, access is blocked
                    across the entire service.
                </p>
            </Section>

            <Section title="Privacy by design">
                <p>
                    Documents you upload are used only to answer your own research
                    questions. Your documents and your prompts are{" "}
                    <strong>never used to train AI models</strong>; our contractual
                    arrangements with our AI provider prohibit it.
                </p>
                <p>
                    You can delete any document at any time. Deletion removes both
                    the original file and the working data derived from it within
                    our standard retention window.
                </p>
            </Section>

            <Section title="Where your data lives">
                <p>
                    EuroLaw Hub is operated from cloud regions in the European
                    Union, and your documents and account data are stored in the
                    EU. Where AI processing involves a transfer outside the EU, it
                    is covered by appropriate contractual safeguards, including
                    Standard Contractual Clauses. See the{" "}
                    <a href="/privacy" className="underline">Privacy Policy</a> for
                    the full list of processors and safeguards.
                </p>
            </Section>

            <Section title="Resilience">
                <p>
                    Your work is backed up regularly, backups are encrypted, and
                    our ability to recover is tested. If something goes wrong, our
                    priority is restoring your access to your saved work quickly
                    and safely.
                </p>
            </Section>

            <Section title="If something goes wrong (GDPR Art. 33)">
                <p>
                    In the event of a personal-data breach, EuroLaw Hub will notify
                    the competent supervisory authority without undue delay and
                    where feasible within 72 hours of becoming aware, as Article 33
                    GDPR requires. Where a breach is likely to pose a high risk to
                    you, we will also tell you directly, in clear and plain
                    language, what happened and what we are doing about it.
                </p>
            </Section>

            <Section title="Responsible disclosure">
                <p>
                    Security researchers are welcome. If you believe you have found
                    a vulnerability or have a security concern, please report it to{" "}
                    <a href="mailto:altay@eurolawhub.com" className="underline">
                        altay@eurolawhub.com
                    </a>
                    . We will acknowledge your report within three business days and
                    work with you in good faith. Please do not access other users'
                    data while investigating.
                </p>
            </Section>
        </LegalShell>
    );
}
